<div 
    *ngIf="this.case && !this.loading" class="z-20 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); onCloseClick();"
>
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="h-full w-full max-w-screen-md flex flex-col my-6 p-8 gap-4 bg-white rounded-md shadow-lg overflow-y-auto" (click)="$event.stopPropagation()">
            <div class="w-full flex flex-col items-center justify-between">
                <h2 class="w-full text-center oswald-font text-3xl text-nside-orange-400">Files</h2>
                <h2 class="w-full text-center text-lg">Case {{ case.case_id }}</h2>
            </div>
            <div class="w-full h-full overflow-y-auto py-1 pr-2 rounded-md">
                <div class="w-full flex flex-col items-center justify-center gap-2">
                    <div *ngFor="let item of documentsList;" class="w-full flex flex-col gap-2">
                        <div class="w-full">
                            <h3 class="font-semibold text-lg">{{ item.stage }}</h3>
                        </div>
                        <div *ngFor="let doc of item.docs;" class="w-full flex items-center justify-center px-4 py-2 rounded-md border shadow bg-white">
                            <div class="w-4/5 flex items-center justify-start gap-1">                            
                                <lucide-icon [img]="icons.FileText" class="w-5 h-5 text-nside-orange-400"></lucide-icon>
                                <p class="w-full text-sm font-bold">{{ doc.label }}</p>
                            </div>
                            <div class="w-1/5 flex justify-end">
                                <button 
                                    *ngIf="doc.name !== 'roar_assignment_form'"
                                    class="oswald-font"
                                    [ngClass]="{
                                        'text-blue-500 hover:text-nside-orange-400 cursor-pointer': this.case[doc.name] == formStatus.ReviewComplete,
                                        'text-gray-200 cursor-not-allowed': this.case[doc.name] != formStatus.ReviewComplete
                                    }"
                                    [disabled]="this.case[doc.name] != formStatus.ReviewComplete"
                                    (click)="$event.preventDefault(); downloadFile(doc.name, case.case_id);"
                                >
                                    Download
                                </button>
                                <button 
                                    *ngIf="doc.name === 'roar_assignment_form'"
                                    class="oswald-font"
                                    [ngClass]="{
                                        'text-blue-500 hover:text-nside-orange-400 cursor-pointer': isAtLeastOneRoarAssignmentForm(),
                                        'text-gray-200 cursor-not-allowed': !isAtLeastOneRoarAssignmentForm()
                                    }"
                                    [disabled]="!isAtLeastOneRoarAssignmentForm()"
                                    (click)="$event.preventDefault(); downloadFile(doc.name, case.case_id);"
                                >
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-4 flex justify-end gap-4">
                <button
                    class="py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    (click)="$event.preventDefault(); onCloseClick();"
                >
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<popup-message 
    [type]="messageModal"
    (close)="resetMessageModal()"
    [message]="popupMessage"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>